import { render, staticRenderFns } from "./person-center-home.vue?vue&type=template&id=653766f4&scoped=true&"
import script from "./person-center-home.vue?vue&type=script&lang=js&"
export * from "./person-center-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653766f4",
  null
  
)

export default component.exports